import { Divider, List } from '@mui/material';
import ViewModifyTenderListItem from './Actions/ViewModifyLoadTenderListItem';
import AcceptLoadTenderListItem from './Actions/AcceptLoadTenderListItem';
import DeleteLoadTenderListItem from './Actions/DeleteLoadTenderListItem';
import RejectLoadTenderListItem from './Actions/RejectLoadTenderListItem';

import styles from '../../RenderCell.module.css';

export default function RowActionList() {
  return (
    <List
      className={styles.actions}
      disablePadding
      dense>
      <ViewModifyTenderListItem />
      <Divider />
      <AcceptLoadTenderListItem />
      <RejectLoadTenderListItem />
      <DeleteLoadTenderListItem />
    </List>
  );
}
